import React from "react";
import { PageBanner } from "../components/common";
import { BlogCard } from "../sections/Blog";
import { blog } from "../mock";
import Gallery from "../sections/Gallery";

const NewsPage = () => {
  return (
    <main>
      <PageBanner
        title="News &amp; Insight"
        crumb="News"
        image="https://images.unsplash.com/photo-1541888946425-d81bb19240f5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
      />
      <section className="py-24 bg-white">
        <div className="max-w-[1320px] mx-auto px-5 grid md:grid-cols-2 lg:grid-cols-3 gap-7">
          {blog.map((b) => (
            <BlogCard key={b.id} b={b} />
          ))}
        </div>
      </section>
      <Gallery />
    </main>
  );
};

export default NewsPage;
